import { Directive, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appFlagExternal]'
})
export class FlagExternalDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    
  }

  ngOnInit() {
    this.update();
  }

  update() {
    if (environment.exportType === 'bookmark') {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
